import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export { twMerge as cx };

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
